import React from "react";
import color from "src/styles/color";

type Props = {
  style?: object;
  fill?: string;
};

const Check: React.SFC<Props> = ({ style, fill = color.white }) => (
  <svg
    style={style}
    width="12"
    height="9"
    viewBox="0 0 12 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 3.72727L4.52941 7L11 1"
      stroke={fill}
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export default Check;
